/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable array-callback-return */
import CardMyHistory from 'components/atoms/card_my_history';
import PieGraphic from 'components/atoms/pie_graphic';
import HelpVideoModal from 'components/molecules/help_video_modal';
import React, { useEffect, useRef, useState } from 'react';
import IconExibicao from 'assets/images/icon_exibicao.svg';
import IconChatHistory from 'assets/images/colored_icons/icon_chat_history.svg';
import IconExpiredItems from 'assets/images/colored_icons/icon_expired_items.svg';
import IconMoney from 'assets/images/colored_icons/icon_money.svg';
import colors from 'styles/colors';
import { ApplicationState } from 'store';
import { ModalidadeResumo, MyHistoryState } from 'store/modules/my_history_store/types';
import { useSelector } from 'react-redux';
import ToolButton from 'components/atoms/tool_button';
import { useReactToPrint } from 'react-to-print';
import FollowupsList from 'components/molecules/followups_list';
import { DateRangePicker, FocusedInputShape } from 'react-dates';
import { hasCookie, setCookie } from 'services/actions/cookies_actions';
import OpenTutorial from 'components/atoms/open_tutorial';
import MyHistoryModal from 'components/atoms/my_history_modal';
import ItensList from 'components/molecules/itens_list';
import OrgaosList from 'components/molecules/orgaos_list';
import PortaisList from 'components/molecules/portais_list';
import { Modalities } from 'services/modalities';
import { Container } from './styles';

interface MyHistoryPageProps {
  setPageFollowup: React.Dispatch<React.SetStateAction<number>>;
  pageFollowup: number;
  setPageItens: React.Dispatch<React.SetStateAction<number>>;
  pageItens: number;
  setFiltro: React.Dispatch<React.SetStateAction<string>>;
  filtro: string;
  endDate: moment.Moment | null;
  startDate: moment.Moment | null;
  handleDatesChange: any;
}

const MyHistoryPage = (props: MyHistoryPageProps) => {
  const {
    setPageFollowup,
    pageFollowup,
    setPageItens,
    pageItens,
    setFiltro,
    filtro,
    endDate,
    startDate,
    handleDatesChange,
  } = props;
  const [modalVideoOpened, setModalVideoOpened] = useState<boolean>(true);
  const [regions, setRegions] = useState<Array<string>>([]);
  const [regionsCalc, setRegionsCalc] = useState<Array<number>>([]);
  const [modalidade, setModalidade] = useState<Array<string>>([]);
  const [totalModalidade, setTotalModalidade] = useState<Array<number>>([]);
  const [focusedInput, setFocusedInput] = useState<FocusedInputShape | null>(null);
  const componentRef = useRef() as React.MutableRefObject<HTMLInputElement>;
  const [showModal, setShowModal] = useState<boolean>(false);
  const blurStyle = showModal ? { filter: 'blur(8px)' } : {};

  const { my_history, request, request_followups } = useSelector<ApplicationState, MyHistoryState>(
    (state) => state.session.my_history,
  );

  useEffect(() => {
    setModalVideoOpened(!hasCookie('modalMeuHistorico'));
  }, []);

  useEffect(() => {
    if (modalVideoOpened) setCookie('modalMeuHistorico', true);
  }, [modalVideoOpened]);

  useEffect(() => {
    const regions_name: any[] = [];
    const regions_calc: any[] = [];
    my_history?.licitacoes_por_regiao?.map((region: any) => {
      regions_name.push(region?.regiao);
      regions_calc.push(region?.quantidade);
    });
    setRegions(regions_name);
    setRegionsCalc(regions_calc);
  }, [my_history?.licitacoes_por_regiao]);

  useEffect(() => {
    if (!my_history?.licitacoes_por_modalidade) return;

    const modalidade: string[] = [];
    const total_modalidade: number[] = [];

    my_history.licitacoes_por_modalidade.forEach((mod: ModalidadeResumo) => {
      const sigla = Modalities.find((m) => m.id === mod.modalidade)?.sigla || '—';

      modalidade.push(sigla);
      total_modalidade.push(mod.quantidade);
    });

    setModalidade(modalidade);
    setTotalModalidade(total_modalidade);
  }, [my_history?.licitacoes_por_modalidade]);

  const handleprint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: 'conlicitacao',
  });

  const tiket_medio: number =
    my_history?.total_investimento && my_history?.total_itens_vencidos
      ? Math.floor(my_history.total_investimento / my_history.total_itens_vencidos)
      : 0;

  useEffect(() => {
    if (request?.loaded && my_history?.licitacoes_por_modalidade.length < 1) {
      setShowModal(true);
    }
  }, [request?.loaded, my_history?.licitacoes_por_modalidade]);

  return (
    <Container>
      <div className="container-fluid big-resolutions" ref={componentRef}>
        <div className="row mb-4 px-md-4 py-4">
          <div className="col-md-12">
            <div className="d-md-flex d-block align-items-center mb-3">
              <h4 className="mb-1 mr-3">Meu Histórico</h4>
              <OpenTutorial type="modal" source="my_history" />
            </div>
            <div className="row mb-3">
              <div className="col-md-2">
                <div className="form-group">
                  <label htmlFor="brand">Filtrar por</label>
                  <select
                    id="cardBrand"
                    className="form-control"
                    onChange={(event) => {
                      setFiltro(event.target.value);
                      setPageFollowup(1);
                      setPageItens(1);
                    }}
                    defaultValue=""
                  >
                    <option value="all">Todo período</option>
                    <option value="1">1 mês</option>
                    <option value="3">3 meses</option>
                    <option value="6">6 meses</option>
                    <option value="12">1 ano</option>
                    <option value="0">Definir período</option>
                  </select>
                </div>
              </div>
              <div className="col-md-3">
                {filtro === '0' && (
                  <div>
                    <p className="mb-2">Período</p>
                    <DateRangePicker
                      disabled={false}
                      startDate={startDate}
                      startDateId="daterangepicker_start_date"
                      endDate={endDate}
                      endDateId="daterangepicker_end_date"
                      onDatesChange={handleDatesChange}
                      focusedInput={focusedInput}
                      onFocusChange={(focusedInput) => setFocusedInput(focusedInput)}
                      startDatePlaceholderText="Dê"
                      endDatePlaceholderText="Até"
                      hideKeyboardShortcutsPanel
                      displayFormat="DD/MM/YYYY"
                      isOutsideRange={() => false}
                      showClearDates
                      small
                      numberOfMonths={1}
                    />
                  </div>
                )}
              </div>
              <div className="col-md-6" />
              <div className="col-md-1 text-right mt-4">
                <ToolButton
                  buttonClass="btn btn-primary btn-sm mr-1 mb-md-0 mb-1"
                  buttonName="Imprimir"
                  disabledPopoverText="Imprimir"
                  disabledButton
                  onButtonClick={() => handleprint()}
                />
              </div>
            </div>
            <div className="row" style={blurStyle}>
              <div className="col-md-5">
                <div className="card-deck">
                  <CardMyHistory
                    img={IconExibicao}
                    title="EXIBIÇÕES EM LICITAÇÕES"
                    value={my_history?.followups?.length}
                    color={colors.$purple}
                    request={request_followups}
                  />
                  <CardMyHistory
                    img={IconChatHistory}
                    title="LICITAÇÕES MONITORADAS"
                    value={my_history?.count_bidding_monitored}
                    color={colors.$red}
                    request={request}
                  />
                </div>
                <div className="card-deck mt-3">
                  <CardMyHistory
                    img={IconExpiredItems}
                    title="ITENS VENCIDOS"
                    value={`${my_history?.total_itens_vencidos}`}
                    color={colors.$light_blue}
                    request={request}
                  />
                  <CardMyHistory
                    img={IconMoney}
                    title="TICKET MÉDIO"
                    value={parseFloat(String(tiket_medio)).toLocaleString('pt-br', {
                      style: 'currency',
                      currency: 'BRL',
                    })}
                    color={colors.$medium_green}
                    request={request}
                  />
                </div>
              </div>
              <div className="col-md-3 mb-md-0 mb-3">
                <PieGraphic
                  title="Participações por região"
                  arrayName={regions}
                  arrayNumber={regionsCalc}
                />
              </div>
              <div className="col-md-4">
                <PieGraphic
                  title="Participações por modalidade"
                  arrayName={modalidade}
                  arrayNumber={totalModalidade}
                />
              </div>
            </div>
            <div className="mt-3 card" style={blurStyle}>
              {request && <ItensList setPageItens={setPageItens} pageItens={pageItens} />}
            </div>
            <div className="mt-3 card">
              {request_followups && (
                <FollowupsList setPageFollowup={setPageFollowup} pageFollowup={pageFollowup} />
              )}
            </div>
            <div className="row mt-4">
              <div className="col-md-12">
                <div className="card-deck">
                  <OrgaosList />
                  <PortaisList />
                </div>
              </div>
            </div>
          </div>
          <HelpVideoModal
            modalVideoOpened={modalVideoOpened}
            setModalVideoOpened={setModalVideoOpened}
            urlVideo="https://player.vimeo.com/video/1142401627"
          />
        </div>
        <MyHistoryModal showModal={showModal} setShowModal={setShowModal} />
      </div>
    </Container>
  );
};
export default MyHistoryPage;
